var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookIc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 42 42"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13286"
}, /*#__PURE__*/React.createElement("path", {
  d: "m25.66 22.2.564-3.678h-3.529v-2.386a1.84 1.84 0 0 1 2.074-1.987h1.6v-3.131a19.5 19.5 0 0 0-2.848-.249c-2.906 0-4.805 1.762-4.805 4.95v2.8h-3.231v3.678h3.231v8.89h3.975v-8.89Z",
  "data-name": "Path 5981"
}))));
export { SvgFacebookIc as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook_ic.1a08f0db41664acf57fa36351b02b3f9.svg";